import React, { useState } from "react";
import TagTreeDataInfo from "../TagTreeDataInfo";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";
import Icon from "../../../Icon";
import { Tooltip } from "antd";
import { FolderTypeNames } from "../../../config/permissions.config";
import { useTranslation } from "../../../context";
import { useNavigator } from "@/utils/NetworkCheck";
import styles from "./index.module.less";

function RootTreeNodeTitle(props: any) {
  const onLine = useNavigator.onLine;
  const {
    treeDataInfo,
    expandedKeys,
    setExpandedKeys,
    folderInfoMap,
    setFolderInfoMap,
    updateTreeDataInfo,
    item,
    theclstag,
    lang,
    width,
    loadData,
    updateFolderInfoMap
  } = props;

  const [visible, setVisible] = useState(false);

  return (
    <div
      className={`${styles["tag-container"]} "nav-tree-item-title`}
      log-analysis-data={
        "xtbj_jzb_joyspace_leftMenu_1676552595819|" +
        `${[null, "myspace", "teamRoot", "collections", "trashes", "home", "knowledge"].indexOf(
          item?.id
        )}` // 埋点id：1-6 分别为我的文件、共享文件、收藏列表、回收站、首页、知识库
      } //
      {...theclstag}
      id={item?.id}
      onClick={() => {
        if (expandedKeys.indexOf(item?.id) === -1) {
          loadData({ key: FolderTypeNames.TAGS });
          setExpandedKeys([...expandedKeys, item?.id]);
        } else {
          setExpandedKeys([...expandedKeys.filter((id: string) => id !== item?.id)]);
        }
      }}
      onMouseEnter={() => {
        setVisible(true);
      }}
      onMouseLeave={() => {
        setVisible(false);
      }}
    >
      <div className="nav-item-content">
        <Icon type="iconbiaoqian" />
        <div style={{ display: "flex", justifyContent: "space-between", flex: 1 }}>
          <div className="nav-item-name" style={{ width: `calc(${width} - 30%)` }}>
            {lang(item?.name)}
          </div>
          {visible && onLine && (
            <Tooltip placement="top" title={lang("tags.create")}>
              <span
                onClick={async (e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  const curTreeDataInfo = new TagTreeDataInfo({ isNew: true });
                  if (expandedKeys.indexOf(item?.id) === -1) {
                    await loadData({ key: FolderTypeNames.TAGS });
                    setExpandedKeys([...expandedKeys, item?.id]);
                  }
                  updateFolderInfoMap({
                    [curTreeDataInfo.id]: curTreeDataInfo
                  });
                  const index = treeDataInfo.findIndex(
                    (data: TagTreeDataInfo) => data.type === FolderTypeNames.TAGS
                  );
                  !treeDataInfo[index].children && (treeDataInfo[index].children = []);
                  treeDataInfo[index].children.unshift({ id: curTreeDataInfo.id });
                  updateTreeDataInfo([...treeDataInfo]);
                }}
              >
                <span>
                  <Icon type="iconbtn_add" className={`${styles["iconadd"]}`} />
                </span>
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    treeDataInfo: joyspace.treeDataInfo,
    expandedKeys: joyspace.expandedKeys,
    folderInfoMap: joyspace.folderInfoMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setExpandedKeys(data: any) {
      dispatch({ type: "joyspace/setExpandedKeys", payload: data });
    },
    setFolderInfoMap(data: any) {
      return dispatch({ type: "joyspace/setFolderInfoMap", payload: { ...data } });
    },
    updateTreeDataInfo(data: any) {
      return dispatch({ type: "joyspace/updateTreeDataInfo", payload: data });
    },
    updateFolderInfoMap(data: any) {
      return dispatch({ type: "joyspace/updateFolderInfoMap", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RootTreeNodeTitle);
